import {HTTP_METHODS} from '../httpMethods'

export const PROMOTION_TYPES_CONFIG = {
  PROMOTION_TYPES: {
    endPoint: 'promotion/config',
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.GET,
    headers: {
      scope: 'pepsi',
    },
  },
  UPDATE_PROMOTION_CONFIG: {
    endPoint: 'promotion/config',
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.PATCH,
    headers: {
      scope: 'pepsi',
    },
  },
  GET_PROMOTION_CONFIG: {
    endPoint: 'promotion/config',
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.GET,
    headers: {
      scope: 'pepsi',
    },
  },
  CREATE_PROMOTION: {
    endPoint: 'promotion',
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.POST,
    headers: {
      scope: 'pepsi',
    },
  },
  UPDATE_PROMOTION: promotionId => ({
    endPoint: `promotion/${promotionId}`,
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.PUT,
  }),
  UPLOAD_PROMOTION_MEDIA: promotionId => ({
    endPoint: `promotion/${promotionId}/media`,
    method: HTTP_METHODS.POST,
    baseUrlKey: 'inventoryApiUrl',
  }),
  PROCESS_PROMOTION_FILE: promotionId => ({
    endPoint: `promotion/file/${promotionId}/process`,
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.POST,
  }),
  UPDATE_PROMOTION_STATUS: (promotionId, status) => ({
    endPoint: `promotion/${promotionId}/status/${status}`,
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.PATCH,
  })
}
